export const IKEA_COMPANY_IDENTIFIERS = ["ikea"];
export const AGATA_COMPANY_IDENTIFIERS = ["agata"];

function includesIdentifier(value = "", identifiers = []) {
    const normalizedValue = typeof value === "string" ? value.toLowerCase() : "";
    if (!normalizedValue.length) {
        return false;
    }

    return identifiers.some(identifier => normalizedValue.includes(identifier));
}

export function isIkeaCompany(realUserCompany = {}) {
    if (!realUserCompany) {
        return false;
    }

    const code = typeof realUserCompany.code === "string" ? realUserCompany.code.toLowerCase() : "";
    const name = typeof realUserCompany.name === "string" ? realUserCompany.name.toLowerCase() : "";

    return IKEA_COMPANY_IDENTIFIERS.some(identifier => {
        return code === identifier || name.includes(identifier);
    });
}

export function isAgataCompany(realUserCompany = {}) {
    if (!realUserCompany) {
        return false;
    }

    const code = typeof realUserCompany.code === "string" ? realUserCompany.code.toLowerCase() : "";
    const name = typeof realUserCompany.name === "string" ? realUserCompany.name.toLowerCase() : "";
    const industry = typeof realUserCompany.industry === "string" ? realUserCompany.industry.toLowerCase() : "";

    return AGATA_COMPANY_IDENTIFIERS.some(identifier => {
        return code === identifier || name.includes(identifier) || industry.includes(identifier);
    });
}

export function isAgataOrderDetails(orderDetails = {}) {
    if (!orderDetails || typeof orderDetails !== "object") {
        return false;
    }

    if (isAgataCompany(orderDetails.realUserCompany)) {
        return true;
    }
    if (isAgataCompany(orderDetails.user && orderDetails.user.company ? orderDetails.user.company : null)) {
        return true;
    }

    const industry = orderDetails.order && typeof orderDetails.order.industry === "string" ? orderDetails.order.industry : "";
    const orderType = orderDetails.order && typeof orderDetails.order.type === "string" ? orderDetails.order.type : "";
    const senderName = orderDetails.sender && typeof orderDetails.sender.name === "string" ? orderDetails.sender.name : "";

    return includesIdentifier(industry, AGATA_COMPANY_IDENTIFIERS) || includesIdentifier(orderType, AGATA_COMPANY_IDENTIFIERS) || includesIdentifier(senderName, AGATA_COMPANY_IDENTIFIERS);
}

export function isAssemblyOrderDetails(orderDetails = {}) {
    const order = orderDetails.order || {};
    const orderType = typeof order.type === "string" ? order.type : "";

    return orderType.toLowerCase() === "assembly";
}
